import AiAssignmentDesignerView from "@features/tools/view/ai-assignment-designer";

const AiAssignmentDesigner = () => {
  return <AiAssignmentDesignerView />;
};

export default AiAssignmentDesigner;
